(() => {
  'use strict';

  // CARBO V5: Keep the visible header cart count in sync even if a Shopify
  // app or a custom add-to-cart implementation does not dispatch cart:update.
  if (window.__tpCartBadgeSyncV5) return;
  window.__tpCartBadgeSyncV5 = true;

  const originalFetch = window.fetch;
  if (typeof originalFetch !== 'function') return;

  const cartUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return new URL('cart.js', new URL(root, location.origin)).toString();
  };

  const isCartWrite = (url, method) => {
    if (!/^(POST|PUT|PATCH|DELETE)$/i.test(String(method || 'GET'))) return false;
    try {
      const parsed = new URL(url instanceof Request ? url.url : String(url), location.href);
      return parsed.origin === location.origin &&
        /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/i.test(parsed.pathname);
    } catch (_) {
      return false;
    }
  };

  let refreshSequence = 0;
  let debounceHandle = 0;

  const renderCount = (count) => {
    const shown = count > 0;
    const shortCount = count < 100 ? String(count) : '99+';

    // The ACTIVE CARBO header uses the custom TP navigation, NOT Horizon's
    // <cart-icon> element. Update that badge and its accessible link label.
    document.querySelectorAll('.tp-nav__cart-button').forEach((button) => {
      const badge = button.querySelector('.tp-nav__cart-count');
      if (!badge) return;
      if (badge.textContent.trim() !== shortCount) badge.textContent = shortCount;
      badge.classList.toggle('is-empty', !shown);
      button.setAttribute('aria-label', `Warenkorb öffnen, ${count} Artikel`);
    });

    // Also update the textual count in the custom mobile menu.
    document.querySelectorAll('.tp-nav__mobile-cart-count').forEach((element) => {
      element.textContent = String(count);
    });

    // Keep native Horizon support for any pages/sections that use it.
    document.querySelectorAll('cart-icon').forEach((icon) => {
      const bubble = icon.querySelector('[ref="cartBubble"]');
      const number = icon.querySelector('[ref="cartBubbleCount"]');
      if (!bubble || !number) return;

      const shown = count > 0;
      const label = count < 100 ? String(count) : '99+';
      if (number.textContent?.trim() !== label) number.textContent = label;
      number.classList.toggle('hidden', !shown);
      bubble.classList.toggle('visually-hidden', !shown);
      icon.classList.toggle('header-actions__cart-icon--has-cart', shown);
    });
  };

  const refresh = async () => {
    const sequence = ++refreshSequence;
    try {
      const response = await originalFetch.call(window, cartUrl(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const data = await response.json();
      const count = Number(data?.item_count);
      if (sequence !== refreshSequence || !Number.isSafeInteger(count) || count < 0) return;
      renderCount(count);
    } catch (_) {
      // A failed count request must never interrupt the purchase flow.
    }
  };

  const scheduleRefresh = () => {
    if (debounceHandle) clearTimeout(debounceHandle);
    debounceHandle = setTimeout(() => {
      debounceHandle = 0;
      void refresh();
    }, 35);
  };

  // Native Horizon uses this event; the fallback also supports apps whose
  // successful POST /cart/add.js bypasses the event system.
  document.addEventListener('cart:update', scheduleRefresh);
  document.addEventListener('shopify:section:load', scheduleRefresh);
  window.addEventListener('pageshow', scheduleRefresh);

  // Observe successful Shopify AJAX cart writes without modifying their
  // responses, request payloads or result promises.
  window.fetch = function (...args) {
    const result = originalFetch.apply(window, args);
    try {
      const request = args[0];
      const method = args[1]?.method || (request instanceof Request ? request.method : 'GET');
      if (isCartWrite(request, method)) {
        Promise.resolve(result)
          .then((response) => { if (response.ok) scheduleRefresh(); })
          .catch(() => {});
      }
    } catch (_) {
      // Leave callers untouched.
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
  } else {
    scheduleRefresh();
  }
})();